export default __webpack_public_path__ + "static/media/kiama4.709b4045.jpg";